/** @jsxImportSource theme-ui */
import { Box, Text, useThemeUI } from "theme-ui";
import { useDispatch } from "react-redux";

import InfoButton from "components/InfoButton";
import { displayInfoModal } from "store/app/appSlice";
import * as styles from "./PriceNotice.styles";

export default function PriceNotice() {
  const dispatch = useDispatch();
  const {
    theme: { isDesktop },
  } = useThemeUI();
  const { title, message, tooltip } = window.customizerContent || {};

  if (!message) return null;

  const hasTooltip = title || tooltip;

  return (
    <Box sx={styles.container}>
      <Text sx={styles.noticeText({ isDesktop })}>{message}</Text>
      {hasTooltip && (
        <InfoButton
          onClick={() => dispatch(displayInfoModal({ title, text: tooltip }))}
          aria-label="More info"
        />
      )}
    </Box>
  );
}
